<template>
    <div class="miniStats">
        <p>{{ title }}</p>
        <p>{{ value }}</p>
    </div>
</template>

<script>
    export default {
        props:['title', 'value']
    }
</script>

<style scoped>
    .miniStats p:first-child {
        font-size: 16px;
        color: #BCBCBC;
        margin-bottom: 4px;
    }
    .miniStats p:last-child {
        font-size: 20px;
        color: #000000;
        margin: 0;
    }
</style>